import React from 'react';
import logo from "../../assets/vp_logo_doc.jpg"

const Contract = ({data,height}) => {
    return (
        <div className="p-4 touch-auto overflow-auto" style={{height:height-12*16}}>
            <img src={logo} alt="" className="w-[100px]"/>
            <h3 className="text-[#008000] mt-4 text-center font-bold text-sm">GIẤY ĐỀ NGHỊ NÂNG CẤP GÓI SẢN PHẨM
                E-KYC</h3>
            <div className="mb-1 font-bold text-sm">Kính gửi: Ngân hàng TMCP Việt Nam Thịnh Vượng</div>
            <div className="border border-black">
                <div className="bg-[#008000] text-white p-1 text-xs">
                    I. THÔNG TIN KHÁCH HÀNG
                </div>
                <div className="p-1 text-xs">
                    <p>Họ và tên: {data?.fullName}</p>
                    <p>Số CMND/Thẻ căn cước công dân: {data?.identityNumber}&nbsp;&nbsp;Ngày cấp: {data?.dateOfIssue}&nbsp;&nbsp;Nơi cấp: {data?.placeOfIssue}</p>
                </div>
                <div className="bg-[#008000] text-white p-1 text-xs">
                    II. ĐỀ NGHỊ NÂNG CẤP SẢN PHẨM, DỊCH VỤ
                </div>
                <div className="p-1 text-xs">
                    <p>Tôi đề nghị VPBank nâng cấp sản phẩm, dịch vụ Tôi đã đăng ký như sau:</p>
                    <ul className="list-decimal pl-4">
                        <li>Chuyển đổi loại tài khoản của Tài khoản thanh toán số {data?.accountNumber}: Chuyển đổi từ Tài khoản
                            thanh toán E-KYC thành Tài khoản thanh toán {data?.accountType}.
                        </li>
                        <li>Chuyển đổi gói dịch vụ ngân hàng điện tử: Chuyển đổi từ Gói E-KYC thành Gói Tiêu chuẩn.</li>
                    </ul>
                </div>
                <div className="bg-[#008000] text-white p-1 text-xs">
                    III. XÁC NHẬN VÀ CAM KẾT CỦA KHÁCH HÀNG
                </div>
                <div className="p-1 text-xs">
                    <p>Tôi xác nhận và cam kết rằng:</p>
                    <ul className="list-decimal pl-4">
                        <li>
                            Các thông tin nêu trên là chính xác, cập nhật, đầy đủ và đồng ý để VPBank xác thực các thông
                            tin nêu trên từ bất kỳ nguồn thông tin nào mà VPBank có được.
                        </li>
                        <li>Giấy đề nghị này được Tôi ký bằng Chữ ký điện tử. Chữ ký điện tử của Tôi được tạo lập dưới
                            dạng từ, chữ, số, ký hiệu... được VPBank xác nhận thông qua việc Tôi thực hiện các hành động
                            như kê khai/xác nhận thông tin nâng cấp sản phẩm, dịch vụ trên màn hình giao dịch và/hoặc
                            qua cuộc gọi với VPBank; được VPBank nhận diện và xác minh thông qua giấy tờ tùy thân, dấu
                            hiệu sinh trắc học (khuôn mặt...) và sự hiện diện của Tôi trong cuộc gọi; kích chọn chấp
                            thuận/tiếp tục trên hệ thống và nhập mã OTP để hoàn tất giao dịch. Giấy đề nghị này được coi
                            là đã được ký kết hợp lệ bởi Tôi khi VPBank xác thực được Tôi và xác nhận sự chấp thuận của
                            Tôi với Giấy đề nghị này thông qua xác thực các yếu tố và quá trình Tôi thực hiện các hành
                            động để hoàn tất giao dịch nêu trên.
                        </li>
                        <div className="flex flex-col items-center mt-4 text-xs">
                            <p className="font-bold">Khách hàng</p>
                            <p>(đã ký bằng Chữ ký điện tử)</p>
                            <p>{data?.fullName}</p>
                        </div>
                        <div className="text-xs italic mt-8">
                            Khách hàng {data?.fullName} đã thực hiện cuộc gọi video call với VPBank lúc {data?.createdDateTime} để thực hiện nâng cấp, nhập mã OTP gửi đến số điện thoại đã đăng ký với VPBank để
                            hoàn thành giao dịch.
                        </div>
                    </ul>
                </div>
                <div className="p-1 border-t border-t-black text-xs">
                    <div className="font-bold text-center">PHẦN XÁC NHẬN CỦA NGÂN HÀNG</div>
                    <div>
                        VPBank đồng ý nâng cấp theo để nghị của Khách hàng tại Mục II của Giấy đề nghị này bao gồm:
                    </div>
                    <ol className="list-item">
                        <li className="before:content-['✓'] before:mr-2">Chuyển đổi loại TKTT</li>
                        <li className="before:content-['✓'] before:mr-2">Chuyển đổi gói dịch vụ ngân hàng điện tử</li>
                    </ol>
                    <div className="flex flex-col items-center mt-4 text-xs">
                        <p className="font-bold">Ngân hàng TMCP Việt Nam Thịnh Vượng (VPBank)</p>
                        <p>(đã ký)</p>
                        <p>Phạm Long Giang</p>
                        <p>Chức vụ: Giám đốc Trung tâm Dịch vụ Ngân hàng số</p>
                        <p>Khối Khách hàng cá nhân</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Contract